<script>
import Sticky from 'sticky-js'
import { appComputed, cartComputed } from '@state/helpers'
import SearchPanel from '@components/search-panel'
import SearchPanelMobile from '@components/search-panel-mobile'
import CartPanel from '@components/cart-panel'
import CartDetails from '@components/cart-details'
import { mapGetters } from 'vuex'

export default {
  components: { SearchPanel, SearchPanelMobile, CartPanel, CartDetails },
  computed: {
    ...appComputed,
    ...cartComputed,
    ...mapGetters('cart/rooms', { roomCartIsEmpty: 'isEmpty' }),
  },
  created() {
    // this.onResize()
    this.sticky = new Sticky('.search-bar', {
      stickyFor: 769,
      wrap: true,
      stickyClass: 'shadow-md',
      stickyContainer: 'main',
    })
  },
  destroyed() {
    this.sticky.destroy()
  },
}
</script>

<template>
  <section class="bg-gray-200 search-bar z-10">
    <div class="container container-page mx-auto">
      <div class="flex flex-wrap px-6 py-4">
        <div class="w-full md:w-2/3">
          <SearchPanel />

          <SearchPanelMobile />
        </div>

        <div
          v-show="!roomCartIsEmpty && $route.name !== 'property-booking'"
          class="mt-auto w-full md:w-1/3 z-10 fixed md:relative bottom-0 inset-x-0 bg-gray-200 md:bg-transparent px-6 md:px-0 border-t-2 md:border-t-0 border-gold-500"
        >
          <CartPanel class="mt-0 md:mt-6" />

          <BaseTransitionExpand>
            <CartDetails v-show="showCartDetails" />
          </BaseTransitionExpand>
        </div>
      </div>
    </div>
  </section>
</template>
